function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#cacdd9;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-205 -321)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 20,
  height: 20,
  transform: "translate(205 321)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M15.363,0H2.637A2.64,2.64,0,0,0,0,2.637V15.363A2.64,2.64,0,0,0,2.637,18H7.945V11.637H5.836V8.473H7.945V6.328a3.168,3.168,0,0,1,3.164-3.164h3.2V6.328h-3.2V8.473h3.2l-.527,3.164H11.109V18h4.254A2.64,2.64,0,0,0,18,15.363V2.637A2.64,2.64,0,0,0,15.363,0Zm0,0",
  transform: "translate(206 322)"
}));

function SvgFacevook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacevook);
export default __webpack_public_path__ + "static/media/facevook.fdaca6c3.svg";
export { ForwardRef as ReactComponent };